export const operationDetailsPageInitValue = {
  data: {
    operation: undefined,
    documents: [],
    partners: [],
    totalPartners: 0,
    currentPage: 1,
    rowsPerPage: 10,
    isIndependentOperation: false,
    isOldOperation: false,
    isLoading: false,
  },
  actions: {
    fetchDocuments: () => {},
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleOpenDividendModal: () => {},
    handleNotifyPartners: () => {},
    handleGenerateTaxDeclaration: async () => {},
    handleGenerateBankDocument: async () => {},
  },
};
